<template>
  <ResetPassword
    :email="email"
    :loading="sendingPasswordEmail"
    :form-error="resetPasswordEmailError"
    :errors="$v"
    :success-message="successMessage"
    :disable="sentEmail || sendingPasswordEmail"
    @update:email="updateEmail"
    @logIn="logIn"
    @sendResetPasswordEmail="sendEmail"
  />
</template>

<script>
import { mapMutations, mapState, mapActions } from 'vuex';
import validations from './validations';

export default {
  name: 'ResetPasswordWidget',
  validations,
  data() {
    return {
      sentEmail: false
    };
  },
  computed: {
    ...mapState({
      email: (state) => state.user.email,
      sendingPasswordEmail: (state) => state.user.sendingPasswordEmail,
      resetPasswordEmailError: (state) => state.user.resetPasswordEmailError
    }),
    successMessage() {
      if (this.sentEmail) {
        return 'if you have an account we will send you an email with instructions on how to reset your password';
      }
      return undefined;
    }
  },
  methods: {
    ...mapMutations('user', [
      'setEmail',
      'clearResetPasswordData',
      'setResetPasswordEmailError'
    ]),
    ...mapActions('user', ['resetPasswordEmail']),
    updateEmail(email) {
      this.setEmail(email);
      this.setResetPasswordEmailError(undefined);
    },
    async logIn() {
      this.$router.push({
        name: this.$auth.isAuthenticated
          ? this.$RouteNames.dashboard
          : this.$RouteNames.login
      });
    },
    async sendEmail() {
      this.$v.$touch();
      if (this.$v.$error) {
        return;
      }
      try {
        await this.resetPasswordEmail(this.email);
        this.sentEmail = true;
      } catch (e) {}
    }
  },
  created() {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    const isFromAuth0CreatePassword = 'success' in params;

    if (isFromAuth0CreatePassword && params['success'] === 'true') {
      this.$router.push({ name: this.$RouteNames.login });
    }
  },
  mounted() {
    this.clearResetPasswordData();
  },
  components: {
    ResetPassword: () => import('../../components/page/reset-password')
  }
};
</script>
